<div class="contain-popup">
  <ng-template #content let-modal>
    <div class="forborder">
      <div class="modal-header">
        <i class="fa fa-times mng-qualifier-close-btn" style="margin-left: 450px;"
           (click)="modal.dismiss('Cross click')" title="close">
        </i>
      </div>
      <div class="modal-body">
        <div class="newBorder">
          {{'pleasecontact'|translate}}: wdmoeuhl@msxi.com
        </div>
      </div>
    </div>
  </ng-template>
</div>
<div *ngIf="isShowNavBar && !showUnauthorizedAccessPage">
  <div class="no-print">
    <div class="container startup-c">
      <div class="row" [class.whats-new-hidden]="!showWhatsNew" [class.admin-mode]="superAdmin">
        <div class="col-sm-7">
          <div class="button-group-flex">
            <button type="button" class="btn btn-primary shadow-none" [disabled]="isDisableStartDiagnosticBtn"
                    (click)="openModal(); hideWhatsNewBox()">{{'START DIAGNOSIS'|translate}}</button>

            <button type="button" class="btn btn-primary shadow-none" [disabled]="isDisableResumeBtn"
                    (click)="hideNetworkTestBlock();resumeBtnClick();hideWhatsNewBox()" routerLink="/vehicleSessions">{{'RESUME SESSION'|translate}}</button>
            <button type="button" class="btn btn-primary shadow-none" [disabled]="isDisableDiagnosticBtn"
                    (click)="hideNetworkTestBlock();diagnosticBtnClick(); hideWhatsNewBox()">{{'DIAGNOSTIC COMPONENTS'|translate}}</button>
            <button *ngIf="showSBDAdminTab" type="button" class="btn btn-primary shadow-none"
                    [disabled]="isDisableAdminBtn" (click)="hideNetworkTestBlock();adminBtnClick(); hideWhatsNewBox()"
                    routerLink="/admin">{{'ADMIN'|translate}}</button>
            <button type="button" class="btn btn-primary shadow-none" [disabled]="isDisableNetworkTestBtn"
                    (click)="hideNetworkTestBlock();networkTestBtnClick();">{{'Network Test'|translate|uppercase}}</button>
            <button *ngIf="showSBDAdminTab && username == 'jharr635' || username == 'dmatth14' " type="button"
                    class="btn btn-primary shadow-none" [disabled]="!isRAPAvailable"
                    (click)="openGtacRAPConfirmationPopUp();hideWhatsNewBox()"
                    data-title="To report a technical problem please use 'Contact Technical Assistance Centre' button above">{{'Report A Problem'|translate}}</button>
            <button *ngIf="showDataCollectorBtn" type="button" class="btn btn-primary shadow-none"
                    (click)="hideNetworkTestBlock();dataCollectorBtnClick();hideWhatsNewBox()"
                    routerLink="/dataCollectorInfo">{{'DataCollectorBtn'|translate}}</button>
            <button type="button" class="btn btn-primary shadow-none"  [disabled]="isDisableDTCBtn"
                    (click)="hideNetworkTestBlock();DTCBtnClick();hideWhatsNewBox()">{{'DTCData'|translate}}</button>
            <button type="button" class="btn btn-primary shadow-none"
                    (click)="openGtacPreCheck(gtacPreCheckTemplate);hideWhatsNewBox()">{{'RAISE GTAC'|translate}}</button>
            <button *ngIf="showTempDealerBtn" type="button" class="btn btn-primary shadow-none"(click)="hideNetworkTestBlock();hideWhatsNewBox()"
                    routerLink="/tempDealer">TEMP DEALER CODE</button>
            <button type="button" class="btn btn-primary shadow-none"(click)="hideNetworkTestBlock();hideWhatsNewBox()"
                    routerLink="/helpdeskrvc">{{'Helpdesk RVCs'|translate}}</button>
          </div>
          <div class="start-diagnosis-text">
            {{'Start online diagnosis for VIN or Registration Number'|translate}} <b>{{Vinnumber}}</b>.
          </div>

          <!-- Network Test containers: Rendered here ONLY WHEN Whats New is visible AND has a scrollbar -->
          <ng-container *ngIf="showWhatsNew && whatsNewHasScrollbar">
            <ng-template [ngTemplateOutlet]="networkTestContent"></ng-template>
          </ng-container>

        </div>
        <div class="col-sm-5">
          <div class="whats-new-container" *ngIf="showWhatsNew" #whatsNewContainer [class.adding-message]="isAddingNewMessage" [class.editing-message]="showEditForm">
            <div class="whats-new-header header-bar">
              <p style="height: 9px; text-align: center;">
                {{'whatsNew' | translate}}
              </p>
              <select class="periodSelect" id="period" [(ngModel)]="selectedPeriod" (ngModelChange)="selectPeriod()">
                <option value="90">{{'last90Days' | translate}}</option>
                <option value="60">{{'last60Days' | translate}}</option>
                <option value="30">{{'last30Days' | translate}}</option>
              </select>
            </div>

            <div class="filter-dropdowns">
              <div class="filter-item">
                <label for="market"><b>{{'Country' | translate}}</b></label>
                <ng-container *ngIf="userTypeId !== 3; else dealerMarketDisplay">
                  <select id="market" [(ngModel)]="selectedMarket" (ngModelChange)="onMarketChange($event)">
                    <option *ngFor="let market of availableMarkets" [value]="market.id3">{{market.name}}</option>
                  </select>
                </ng-container>
                <ng-template #dealerMarketDisplay>
                  <div class="single-market-display">
                    {{ getCountryNameFromCode(selectedMarket) }}
                  </div>
                </ng-template>
              </div>
              <div class="filter-item">
                <label style="margin-left: 3px" for="language"><b>{{'Language' | translate}}</b></label>
                <select id="language" [(ngModel)]="selectedLanguage" (ngModelChange)="onLanguageChange($event)">
                  <option *ngFor="let language of availableLanguages" [value]="language">{{language}}</option>
                </select>
              </div>
              <div class="filter-item new-message-button-container">
                <div class="new-message">
                  <button *ngIf="superAdmin && !isAddingNewMessage && !showEditForm"
                          style="border-radius: 12px; font-size: 9px; font-weight: 700; margin-top: -3px;"
                          type="button" class="close-btn-popup pull-right" name="ok" title="{{'newMessage'|translate}}" (click)="showNewMessageInput()">
                    {{'newMessage'|translate}}
                  </button>
                </div>
              </div>
            </div>
            <div *ngIf="isMessageSaved" class="save-alert">{{'messageSavedSuccess'|translate}}</div>
            <div *ngIf="isMessageDeleted" class="delete-alert">{{'messageDeletedSuccess'|translate}}</div>

            <div *ngIf="isAddingNewMessage" class="message-form new-message-input">
              <h4>{{'addNewMessage'|translate}}</h4>
              <div class="form-group-flex">
                <label for="newMessageHeader"><b>{{'Title'|translate}}:</b></label>
                <input type="text" id="newMessageHeader" [(ngModel)]="newMessageHeader" placeholder="{{'enterTitle'|translate}}" required>
              </div>
              <div class="form-group-flex">
                <label><b>{{'message'|translate}}:</b></label>
                <!-- Quill Editor for New Message -->
                <quill-editor  #newQuillEditor
                               [(ngModel)]="newMessageText"
                               [maxLength]="quillMaxLength"
                               [modules]="editorModules"
                               (onContentChanged)="onNewMessageContentChanged($event)"
                               [placeholder]="'enterMessage'|translate"
                ></quill-editor>
                <div class="char-count">{{ 'Characters Remaining' | translate }}: {{ newMessagesCharRemaining }}</div>
              </div>

              <div class="form-group-flex file-upload-group">
                <label for="addAttachment"><b>{{'attachments'|translate}}:</b></label>
                <!--                <input type="file" id="addAttachment" (change)="onFileSelected($event, 'add')" accept=".pdf">-->
                <label for="addAttachment" class="custom-file-upload">
                  <input type="file" id="addAttachment" (change)="onFileSelected($event, 'add')" accept=".pdf" style="display: none;">
                  <span class="choose-file-button">{{ 'chooseFile' | translate }}</span>
                  <span class="file-name" style="font-weight: 400">{{ selectedFilenameForAdd || ('noFile' | translate) }}</span>
                </label>
              </div>

              <div *ngIf="addValidationError" class="validation-error">{{ addValidationError }}</div>
              <div *ngIf="fileValidationError" class="validation-error">{{ fileValidationError }}</div>

              <div class="edit-actions">
                <div class="color-palette">
                  <span class="color-palette-label" title="{{'chooseMessageColor'|translate}}"> {{'textColor'|translate}}:</span>
                  <button *ngFor="let color of availableColors" (click)="newMessageColor = color" [style.backgroundColor]="color" class="color-option" [class.selected]="newMessageColor === color"></button>
                </div>
                <div class="action-icons">
<!--                  <span class="color-code">{{ getColorName(newMessageColor) }}</span>-->
                  <span class="color-code"></span>
                  <i class="fa fa-check-circle save-icon" (click)="addMessage()" title="{{'saveMessage'|translate}}"></i>
                  <i class="fa fa-times-circle cancel-icon" (click)="cancelAddMessage()" title="{{'Cancel'|translate}}"></i>
                </div>
              </div>
            </div>

            <div *ngIf="showEditForm && editingMessageData" class="message-form edit-message-input">
              <h4>{{'editMessage'|translate}}</h4>
              <div class="form-group-flex">
                <label for="editMessageHeader"><b>{{'Title'|translate}}:</b></label>
                <input type="text" id="editMessageHeader" [(ngModel)]="editingMessageData.type" placeholder="{{'editHeader'|translate}}" required>
              </div>
              <div class="form-group-flex">
                <label><b>{{'message'|translate}}:</b></label>
                <!-- Quill Editor for Edit Message -->
                <quill-editor
                  #editQuillEditor
                  [maxLength]="quillMaxLength"
                  [modules]="editorModules"
                  (onContentChanged)="onEditMessageContentChanged($event)"
                  (onEditorCreated)="onEditEditorCreated($event)"
                ></quill-editor>
                <div class="char-count">{{ 'Characters Remaining' | translate }}: {{ editMessagesCharRemaining }}</div>
              </div>

              <div class="form-group-flex file-upload-group">
                <label><b>{{'attachments'|translate}}:</b></label>
                <ng-container *ngIf="editingMessageData.attachmentFilename && !removeExistingAttachment && !selectedFileForEdit">
                  <span class="existing-file-name">{{ editingMessageData.originalFilename || editingMessageData.attachmentFilename }}</span>
                  <button type="button" class="btn btn-sm btn-danger remove-attachment-btn" (click)="removeAttachment()" title="{{'removeAttachment'|translate}}">{{'remove'|translate}}</button>
                </ng-container>
                <ng-container *ngIf="!editingMessageData.attachmentFilename || removeExistingAttachment || selectedFileForEdit">
                  <label for="editAttachment" class="custom-file-upload">
                    <input type="file" id="editAttachment" (change)="onFileSelected($event, 'edit')" accept=".pdf" style="display: none;">
                    <span class="choose-file-button">{{ 'chooseFile' | translate }}</span>
                    <span class="file-name" style="font-weight: 400">{{ selectedFilenameForEdit || ('noFile' | translate) }}</span>
                  </label>
                </ng-container>

              </div>

              <div *ngIf="editValidationError" class="validation-error">{{ editValidationError }}</div>
              <div *ngIf="fileValidationError" class="validation-error">{{ fileValidationError }}</div>

              <div class="edit-actions">
                <div class="color-palette">
                  <span class="color-palette-label" title="{{'chooseMessageColor'|translate}}">{{'textColor'|translate}}:</span>
                  <button *ngFor="let color of availableColors" (click)="editingMessageData.textColor = color" [style.backgroundColor]="color" class="color-option" [class.selected]="editingMessageData.textColor === color"></button>
                </div>
                <div class="action-icons">
<!--                  <span class="color-code">{{ getColorName(editingMessageData.textColor) }}</span>-->
                  <span class="color-code"></span>
                  <i class="fa fa-check-circle save-icon" (click)="onSaveMessageClicked(currentEditingMessage!)" title="{{'saveMessage'|translate}}"></i>
                  <i class="fa fa-times-circle cancel-icon" (click)="cancelEdit(currentEditingMessage!)" title="{{'cancelMessage'|translate}}"></i>
                </div>
              </div>
            </div>

            <div class="whats-new-messages">
              <table>
                <tbody>
                <tr *ngFor="let message of getSortedMessages(); let i = index" class="message-row" [ngClass]="{'editing': message.isEditing}">
                  <ng-container>
                    <td class="col-new-icon"><span *ngIf="message.isNew" class="new-icon"><img [src]="getNewIconPath()" alt="New" width="35" height="35"></span></td>
                    <td class="col-date"><span class="message-date" style="font-style: oblique; color: #0d0c0d">{{ message.lastEditedDate | date:'MMM dd yyyy' }}</span></td>
                    <td class="col-content">
                      <div class="message-header-text" [style.color]="message.textColor">{{ message.type }}</div>
                      <!-- Display message content using innerHTML -->
                      <div class="message-body" [innerHTML]="getDisplayHtml(message.text)" [style.color]="message.textColor"></div>
                      <div *ngIf="message.attachmentFilename" class="message-attachment">
                        <!-- New link with click handler -->
                        <a href="javascript:void(0)" (click)="downloadAttachment(message.attachmentFilename, message.originalFilename)" title="{{'downloadAttachment'|translate}}">
                          <i class="fa fa-file-pdf-o pdf-icon" aria-hidden="true"></i>
                          <span>{{ message.originalFilename || message.attachmentFilename }}</span>
                        </a>
                      </div>

                    </td>
                    <td class="col-actions">
                      <div class="action-icons-wrapper">
                        <i *ngIf="superAdmin && !isAddingNewMessage && !showEditForm && message.editable"
                           title="{{'editMessage'|translate}}" class="fa fa-pencil edit-icon" (click)="editMessage(message)"></i>
                        <i *ngIf="superAdmin && !isAddingNewMessage && !showEditForm && message.editable"
                           title="{{'deleteMessage'|translate}}" class="fa fa-trash delete-icon"
                           (click)="deleteMessage(message.id); $event.stopPropagation();"></i>
                      </div>
                    </td>
                  </ng-container>
                </tr>
                </tbody>
              </table>
              <div style="font-style: italic; font-weight: 500; color: #003478 !important; margin-left: 50px;" *ngIf="displayedMessages.length === 0" class="no-messages-found">
                {{'noMessage'|translate}}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Network Test containers: Rendered here ONLY WHEN Whats New is NOT visible OR does NOT have a scrollbar -->
      <ng-container *ngIf="!showWhatsNew || !whatsNewHasScrollbar">
        <ng-template [ngTemplateOutlet]="networkTestContent"></ng-template>
      </ng-container>
    </div>
  </div>
</div>

<!--<div style="text-align:center; margin-top:5%" *ngIf="showLoader">-->
<!--  <b> {{'Trying to retrieve FDRS Connection'|translate}}.......</b>-->
<!--  <div><img src="assets/images/ajax-loader.gif" alt="Loading" width="100" height="100"></div>-->
<!--</div>-->

<!-- Define the Network Test content as a reusable template -->
<ng-template #networkTestContent>
  <div style="text-align:center; margin-top:5%" *ngIf="showLoader">
    <b> {{'Trying to retrieve FDRS Connection'|translate}}.......</b>
    <div><img src="assets/images/ajax-loader.gif" alt="Loading" width="100" height="100"></div>
</div>





  <ng-container *ngIf="!fdrsWebSocketConnected && !showLoader && !isHomeBtnsCliked && !showUnauthorizedAccessPage">
    <div [ngClass]="{'fdrs-connection-status-line-withScroll': whatsNewHasScrollbar, 'fdrs-connection-status-line-withoutScroll': !whatsNewHasScrollbar}"
         >
      <label [ngClass]="{'socketStatus': whatsNewHasScrollbar, 'socketStatus-withoutscroll': !whatsNewHasScrollbar}" id="nwHeader">{{'Ford Diagnosis and Repair System not running 1'|translate}}. {{'Please
        start the application on your computer and click on'|translate}}</label><span [ngClass]="{'retryFDRSLink-withScroll': whatsNewHasScrollbar, 'retryFDRSLink': !whatsNewHasScrollbar}"
                                                                                      (click)="retryFDRSConnection();">{{'retry'|translate}}</span>
    </div>
  </ng-container>

  <ng-container *ngIf="isFDRSConnected && !showLoader && !showUnauthorizedAccessPage">
    <ng-container *ngIf="!isDisableNwHeader">
      <label [ngClass]="{'header-margin-networktest-hasscroll': whatsNewHasScrollbar, 'header-margin-networktest-noscroll': !whatsNewHasScrollbar}" id="nwHeader">{{'Network Test'|translate}} </label>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="isNetworkTestNeeded && !showLoader && !showUnauthorizedAccessPage">
    <ng-container *ngIf="isFDRSConnected">
      <ng-container *ngIf="isShowOverrideBlock">
        <div class="start-container">
          <div class="top-section-row">
            <span class="info-icon"><i class="fa fa-info-circle"></i></span>
            <span class="image"></span>
            <label class="lblHeader">{{'Start Here'|translate}}</label>
          </div>
          <label class="lbl-text">{{'network test text1'|translate}}<a>{{'click here'|translate}}.</a></label>
          <label class="lbl-text2">{{'Click the start button to continue'|translate}}</label>
          <!-- Buttons are now correctly wrapped by their designated container -->
          <div class="start-override-buttons-wrapper">
            <button class="btn-start startBtn-info" [attr.aria-label]='info' (click)="startNetworkTest();">{{'Start'|translate}}</button>
            <button class="btn-override" (click)="overrideBtnClicked();">{{'Override'|translate}}</button>
          </div>
          <!-- Group checkbox for consistent spacing -->
          <div class="checkbox-row" *ngIf="isShowDataCollectorCheckBox">
            <span>
              <input type="checkbox" [checked]="isDataCollectorChecked" class="datacollectorCheckbox" [(ngModel)]="isDataCollectorChecked" (change)="getDataCollectorCheckboxStatus(isDataCollectorChecked?'FULL':'SKIP_SPECIFIC')" />
              <span [ngClass]="{'font-size-11px': whatsNewHasScrollbar, 'font-size-14px': !whatsNewHasScrollbar}">{{'DC_NWT_Info'|translate}}</span>
            </span>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>

<ng-container *ngIf="isNetworkTestNeeded && !showLoader && !showUnauthorizedAccessPage">
  <ng-container *ngIf="isFDRSConnected">
    <ng-container *ngIf="isShowTestProgressBlock">
      <div class="network-container">
        <span><i class="fa fa-info-circle" style="color: gray !important;font-size:14px; margin-left: 1%;"></i></span><span><label class="network-test-header">{{'FDRS Network Test Progress'|translate}}</label></span>
        <div *ngIf="!progressbar && !isNetwork && !isNetworkTestError"><label class="network-status">{{'FDRS Network test Not Running'|translate}}</label></div>
        <div *ngIf="progressbar && !isNetwork && !isNetworkFailure" class="progress"><div class="progress-bar progress-bar-striped s row_padding"></div></div>
        <div *ngIf="progressbar && !isNetwork && !isNetworkFailure" style="margin-left: 3%;">{{'Performing Network Test'|translate}}..</div>
        <div *ngIf="isNetwork" style="margin-left: 3%;">{{'Network test is completed successfully'|translate}}.</div>
        <div *ngIf="isNetworkFailure" style="margin-left: 3%;">{{'Network test Fails to complete'|translate}}.</div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>

  <ng-container *ngIf="isShowReRunBlock && !showLoader && !showUnauthorizedAccessPage">
    <ng-container *ngIf="isFDRSConnected">
      <div class="network-container">
              <span><i class="fa fa-info-circle"
                       style="color: gray !important;font-size:14px; margin-left: 1%;"></i></span>
        <span><label class="network-test-header">{{'FDRS Network Test Progress'|translate}}</label></span>
        <!-- <div *ngIf="!progressbar && !isNetwork"> -->
        <label class="network-status" [ngClass]="{'font-size-11px': whatsNewHasScrollbar, 'font-size-14px': !whatsNewHasScrollbar}">{{'Network Test Notifications'|translate}}.<a href="javascript:void(0);"
                                                                                    class="link" [attr.aria-label]='info' (click)="reRunNetworkTest();">{{'Re-run the network
          test'|translate}}</a></label>
        <!-- </div> -->
        <div class="checkbox-row" *ngIf="isShowDataCollectorCheckBox">
                   <span>
            <input type="checkbox" [checked]="isDataCollectorChecked" class="datacollectorCheckbox" [(ngModel)]="isDataCollectorChecked" (change)="getDataCollectorCheckboxStatus(isDataCollectorChecked?'FULL':'SKIP_SPECIFIC')" />
            <span [ngClass]="{'font-size-11px': whatsNewHasScrollbar, 'font-size-14px': !whatsNewHasScrollbar}">&nbsp;&nbsp;{{'DC_NWT_Info'|translate}}</span>
          </span>
        </div>
      </div>

    </ng-container>
  </ng-container>

  <ng-container *ngIf="isNetworkTestError && !showLoader && !showUnauthorizedAccessPage">
    <ng-container *ngIf="isFDRSConnected">
      <div class="network-container">
        <span><i class="fa fa-info-circle" style="color: gray !important;font-size:14px; margin-left: 1%;"></i></span><span><label class="network-test-header">{{'FDRS Network Test Progress'|translate}}</label></span>
        <div><span><label class="network-status" [ngClass]="{'font-size-11px': whatsNewHasScrollbar, 'font-size-14px': !whatsNewHasScrollbar}">{{'FDRS Network Test Failed click to re run'|translate}}</label><button class="btn-start" (click)="retryNetworkTest()">{{'RUN'|translate}}</button></span></div>
        <div class="checkbox-row" *ngIf="isShowDataCollectorCheckBox">
        <span>
            <input type="checkbox" [checked]="isDataCollectorChecked" class="datacollectorCheckbox" [(ngModel)]="isDataCollectorChecked" (change)="getDataCollectorCheckboxStatus(isDataCollectorChecked?'FULL':'SKIP_SPECIFIC')" />
            <span [ngClass]="{'font-size-11px': whatsNewHasScrollbar, 'font-size-14px': !whatsNewHasScrollbar}">{{'DC_NWT_Info'|translate}}</span>
          </span>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="isNWTestFailedMultiple && !showLoader && !showUnauthorizedAccessPage">
    <ng-container *ngIf="isFDRSConnected">
      <div class="network-container">
        <span><i class="fa fa-info-circle" style="color: gray !important;font-size:14px; margin-left: 1%;"></i></span><span><label class="network-test-header">{{'FDRS Network Test Progress'|translate}}</label></span>
        <div><span><label class="network-status" [ngClass]="{'font-size-11px': whatsNewHasScrollbar, 'font-size-14px': !whatsNewHasScrollbar}">{{'FDRS Network Test Failed Message'|translate}}?</label></span>
          <span>
                      <button class="btn-start-multiple" (click)="retryNetworkTest()">{{'RUN'|translate}}</button>
                      <button class="btn-override-multiple"
                              (click)="overrideBtnClicked()">{{'Override'|translate}}</button>
                  </span>
        </div>
        <div class="checkbox-row" *ngIf="isShowDataCollectorCheckBox">
                   <span>
            <input type="checkbox" [checked]="isDataCollectorChecked" class="datacollectorCheckbox" [(ngModel)]="isDataCollectorChecked" (change)="getDataCollectorCheckboxStatus(isDataCollectorChecked?'FULL':'SKIP_SPECIFIC')" />
            <span [ngClass]="{'font-size-11px': whatsNewHasScrollbar, 'font-size-14px': !whatsNewHasScrollbar}">&nbsp;&nbsp;{{'DC_NWT_Info'|translate}}</span>
          </span>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="isNWTestFailedAdmin && !showLoader && !showUnauthorizedAccessPage">
    <ng-container *ngIf="isFDRSConnected">
      <div class="network-container">
        <span><i class="fa fa-info-circle" style="color: gray !important;font-size:14px; margin-left: 1%;"></i></span><span><label class="network-test-header">{{'FDRS Network Test Progress'|translate}}</label></span>
        <div><span><label class="network-status" [ngClass]="{'font-size-11px': whatsNewHasScrollbar, 'font-size-14px': !whatsNewHasScrollbar}">{{'FDRS Network Test Failed continue with previous sdata retry or close'|translate}}?</label><button class="btn-start-failure" (click)="retryNetworkTest()">{{'RUN'|translate}}</button><button class="btn-override-failure"  style="margin-left:1% !important;" (click)="overrideBtnClicked()">{{'Override'|translate}}</button></span></div>
        <div class="checkbox-row" *ngIf="isShowDataCollectorCheckBox">
             <span>
            <input type="checkbox" [checked]="isDataCollectorChecked" class="datacollectorCheckbox" [(ngModel)]="isDataCollectorChecked" (change)="getDataCollectorCheckboxStatus(isDataCollectorChecked?'FULL':'SKIP_SPECIFIC')" />
            <span [ngClass]="{'font-size-11px': whatsNewHasScrollbar, 'font-size-14px': !whatsNewHasScrollbar}">{{'DC_NWT_Info'|translate}}</span>
          </span>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-template>

<ng-template #NWTErrorInfo let-modal>
  <div class="container NWTContainer">
    <div class="row popup-header"><div class="pull-left">{{'Information'|translate}}</div><div class="pull-right cross-button" style="margin-top: -3.6%;" title="close"><i class="fa fa-times" aria-hidden="true" (click)="modal.dismiss('NWTErrorInfo')"></i></div></div>
    <div><label class='msg-body'>{{'An error occurred when running the application'|translate}}. {{'Cause'|translate}}: {{networkTestErrorMsg}}<br>{{'Close the message box and try again'|translate}}.{{'Network Test Message1'|translate}}.</label></div>
    <hr class="hr-line">
    <div class="popup-footer"><button type="button" class="close-btn-popup pull-right" name="cancel" (click)="modal.dismiss('NWTErrorInfo')">{{'CONTINUE'|translate}}</button></div>
  </div>
</ng-template>
<ng-template #gtacRap let-modal>
  <div class="container NWTContainer" style="width: 100%;">
    <div class="row popup-header"><div class="pull-left">{{'Information'|translate}}</div><div class="pull-right cross-button" style="margin-top:-5.6%" title="close"><i class="fa fa-times" aria-hidden="true" (click)="modal.dismiss('NWTErrorInfo')"></i></div></div>
    <div><label class='msg-body'><p>{{'RAPMsg'|translate}}?<br>{{'RAPMsg1'|translate}}.<br>{{'RAPMsg2'|translate}}.<br>{{'RAPMsg3'|translate}}?</p></label></div>
    <hr class="hr-line1">
    <div class="popup-footer"><button type="button" class="close-btn-popup pull-right" name="GTAC" (click)="modal.dismiss('gtacRap');contactSubmit(content)">GTAC</button><button type="button" class="close-btn-popup pull-right" name="RAP" (click)="modal.dismiss('gtacRap');reportAProblemPopup()">RAP</button></div>
  </div>
</ng-template>
<ng-template #VehicleModelMissing let-modal>
  <div class="container version">
    <div class="row popup-header" style="width: 105%;"><div class="pull-left">{{'Information'|translate}}</div><div class="pull-right cross-button" style="margin-top:-5.6%" title="close"><i class="fa fa-times" aria-hidden="true" (click)="modal.dismiss('VehicleModelMissing')"></i></div></div>
    <div><label class='msg-body'><p>{{'VMMissingMsg'|translate}}<br>{{'VMMissingMsg1'|translate}}<br>{{'VMMissingMsg2'|translate}}</p></label></div>
    <hr class="hr-line1">
    <div class="popup-footer"><button type="button" class="close-btn-popup pull-right" name="cancel" (click)="modal.dismiss('VehicleModelMissing');">{{'close'|translate}}</button><button type="button" class="close-btn-popup pull-right" name="cancel" (click)="modal.dismiss('VehicleModelMissing');contactSubmit(content);">{{'Submit'|translate}}</button></div>
  </div>
</ng-template>
<ng-template #DTCInfo let-modal>
  <div class="container NWTContainer">
    <div class="row popup-header"><div class="pull-left">{{'Information'|translate}}</div><div class="pull-right cross-button" style="margin-top: -5.6%;" title="close"><i class="fa fa-times" aria-hidden="true" (click)="modal.dismiss('DTCInfo')"></i></div></div>
    <div><label class='msg-body'>{{'dtcClearInformation'|translate}}</label></div>
    <hr class="hr-line">
    <div class="popup-footer">
      <button type="button" class="close-btn-popup pull-right" name="cancel"
              (click)="modal.dismiss('DTCInfo')">{{'CONTINUE'|translate}}</button>
    </div>
  </div>
</ng-template>

<ng-template #deleteWhatsNew let-modal>
  <div class="container NWTContainer">
    <div class="row popup-header"><div class="pull-left">{{'Confirm'|translate}}</div><div class="pull-right cross-button" style="margin-top: -5.6%;" title="close"><i class="fa fa-times" aria-hidden="true" (click)="modal.dismiss('deleteWhatsNew')"></i></div></div>
    <div><label class='msg-body' style="font-weight: 600; margin-left: 97px;  margin-top: 18px;">{{'confirmDelete'|translate}}</label></div>
    <div class="popup-footer"><button type="button" class="close-btn-popup pull-right" name="cancel" (click)="modal.dismiss('deleteWhatsNew')">{{'No'|translate}}</button><button type="button" class="close-btn-popup pull-right" name="cancel" (click)="confirmDeleteMessage()">{{'Yes'|translate}}</button></div>
  </div>
</ng-template>

<ng-template #gtacPreCheckTemplate let-modal>
  <div class="gtac-precheck-modal">

    <div class="modal-header">
      <button type="button" class="close-button" title="Close" (click)="modal.dismiss('Cross click')">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </div>

    <div class="modal-body">
      <label class="instructions">
        {{'gtacClearInformation'|translate}}
      </label>

      <div class="button-group">
        <button type="button" class="modal-btn" (click)="downloadForm('pdf')">{{'Download PDF'|translate}}</button>
        <button type="button" class="modal-btn" (click)="downloadForm('docx')">{{'Download DOCX'|translate}}</button>
      </div>

      <div *ngIf="isTemplateDownloaded" class="confirmation-section">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="templateCompleteCheck"
                 [(ngModel)]="isTemplateCompleteChecked">
          <!-- More professional and clear label text -->
          <label class="form-check-label" for="templateCompleteCheck">
            {{'I have downloaded and completed the required form'|translate}}
          </label>
        </div>
      </div>
    </div>

    <div *ngIf="isTemplateDownloaded" class="modal-footer">
      <button type="button" class="modal-btn modal-btn-primary"
              (click)="continueToGtac(content)"
              [disabled]="!isTemplateCompleteChecked">
        {{'continue' | translate}}
      </button>
    </div>

  </div>
</ng-template>
<ng-template #browserPopup let-c="close" let-d="dismiss">
    <div class="container ModalContainer">
      <!-- Header -->
      <div class="row popup-browser-header">
        <div class="pull-left">{{'Unsupported Browser'|translate}}</div>
      </div>

      <!-- Body -->
      <div>
        <div class='msg-body'>
          <p>
            <b>{{'BrowserMsg1'|translate}}</b><br>
            {{'BrowserMsg2'|translate}}<b> Google Chrome</b> {{'BrowserMsg3'|translate}}
          </p>
          <div>
            <div class="checkbox">
              <p>
                <input type="checkbox" id="acknowledge" [(ngModel)]="isacknowledged">
                {{'AckMsg'|translate}}
              </p>
            </div>
          </div>
        </div>

      </div>
      <!-- Footer -->
      <div class="modal-footer">
        <button class="btn btn-primary shadow-none"(click)="switchBrowser('Switch')">{{ 'Return to PTS'|translate}}</button>
        <button class="btn btn-primary shadow-none" [disabled]="!isacknowledged" (click)="closeModal('Continue')">{{'Continue Anyway'|translate}}</button>    </div>
    </div>
  </ng-template>


